import { Dropdown } from "primereact/dropdown";
import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";

const Modal = ({ isOpen, onClose, fields, onSave }) => {
  const initialFormState = fields.reduce((acc, field) => {
    acc[field.name] = field.value || "";
    return acc;
  }, {});

  const [formValues, setFormValues] = useState(initialFormState);
  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    const newState = fields.reduce((acc, field) => {
      acc[field.name] = field.value || "";
      return acc;
    }, {});
    setFormValues(newState);
  }, [fields]);

  if (!isOpen) return null;

  const handleInputChange = (e, fieldName) => {
    setFormValues({
      ...formValues,
      [fieldName]: e.target.value,
    });
    if (validationErrors[fieldName]) {
      setValidationErrors({
        ...validationErrors,
        [fieldName]: "",
      });
    }
  };

  const handleSave = () => {
    let errors = {};
    fields.forEach((field) => {
      if (!formValues[field.name] && field.disable !== "true") {
        errors[field.name] = `${field.label} is required`;
      }
    });

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    onSave(formValues);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-primary px-6 py-5 rounded-lg shadow-lg max-w-sm w-full">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-bold text-white">My Profile</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white focus:outline-none"
          >
            <FaTimes />
          </button>
        </div>

        <form>
          {fields.map((field, index) => (
            <div className="mb-4" key={index}>
              <label
                htmlFor={field.name}
                className="block text-md font-medium text-gray-400 mb-2"
              >
                {field.label}
              </label>

              {field.type === "select" ? (
                <Dropdown
                  value={formValues[field.name]}
                  name={field.name}
                  onChange={(e) => handleInputChange(e, field.name)}
                  required
                  options={field.options}
                  optionLabel="label"
                  placeholder="Select a Currency"
                  className={`dropdownMenu w-full bg-transparent border border-[rgb(161,147,147)] rounded-lg focus:ring-blue-500 focus:border-blue-500
                    ${formValues[field.name] ? "asset_Dropdown" : ""}`}
                  checkmark={true}
                  highlightOnSelect={false}
                />
              ) : (
                <input
                  type={field.type || "text"}
                  placeholder={field.label}
                  id={field.name}
                  value={formValues[field.name]}
                  onChange={(e) => handleInputChange(e, field.name)}
                  disabled={field.disable === 'true'}
                  className="p-3 w-full border rounded-lg border-[rgb(161,147,147)] focus:ring focus:ring-blue-500 bg-transparent"
                />
              )}
              {validationErrors[field.name] && (
                <p className="text-red-500 text-sm mt-1">{validationErrors[field.name]}</p>
              )}
            </div>
          ))}

          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-transparent border text-white rounded-md hover:border-red-700"
            >
              Close
            </button>
            <button
              type="button"
              onClick={handleSave}
              className="px-4 py-2 bg-secondary text-primary rounded-md hover:bg-blue-700"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Modal;
